import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { ICourseFinanceListItemFrontEndModel } from "../../types";
import LabeledContent from "../../../../components/LabeledContent";

const useStyles = makeStyles(() => ({
  labeledContent: {
    "& > :first-child": {
      fontSize: 14,
      color: " #828190",
    },
    "& > :last-child": {
      fontSize: 14,
      color: " #535358",
    },
  },
  tuitionContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    minHeight: 74,
  },
}));

interface ICourseFinanceProps {
  finance: ICourseFinanceListItemFrontEndModel[];
}

export const CourseFinance: FC<ICourseFinanceProps> = ({ finance }) => {
  const classes = useStyles();

  return (
    <div className={classes.tuitionContainer}>
      {finance.map(({ label, value }) => (
        <LabeledContent
          key={label}
          className={classes.labeledContent}
          label={label}
        >
          {value}
        </LabeledContent>
      ))}
    </div>
  );
};
